import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DynamicDialogComponent } from 'primeng/dynamicdialog';

@Component({
  selector: 'split-agenda-consulta',
  templateUrl: './agenda-consulta.component.html',
  styleUrls: ['./agenda-consulta.component.scss']
})
export class AgendaConsultaComponent {
  public form : FormGroup = new FormGroup({
    listaEspera : new FormControl('')
  });

  
  hora = '';
  tempo = '';
  servico = '';
  toogleAgendamentosBtn(event: any) {}
  
  constructor(private fb: FormBuilder,public config: DynamicDialogComponent) {}

  optionAgendamentosBtn: any =  [
    { label: 'Visita presencial', value: 'presencial' ,icon: 'bi bi-geo-alt-fill'}, { label: 'Telemedicina', value: 'adistancia', icon: 'bi bi-camera-fill' } 
  ];
  salvar() {
    this.config.close();
  }
  cancelar() {
    this.config.close();
  }
}
